import { render, staticRenderFns } from "./interacciondigiventures.vue?vue&type=template&id=17394f88"
import script from "./interacciondigiventures.vue?vue&type=script&lang=js"
export * from "./interacciondigiventures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports